/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Icon } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import { AutoCompleteProdutosNfe, BasicSelect, IVFormErrors, VFieldMoney, VFieldMoney4, VForm, VSwitch, VTextField, useVForm } from '../../../shared/forms';
import { AutoCompleteCfop } from '../../../shared/forms/AutoCompleteCfop';
import * as yup from 'yup';

interface IFormData {
  iditens: string;
  idprod: string;
  descricao: string;
  un: string;
  ncm: string;
  cfop: number;
  cst: string;
  quantidade: number;
  preco: number;
  desconto: number;
  total: number;
  frete: number;
  seguro: number;
  bcicms: number;
  percentual: number;
  valoricms: number;
  bcst: number;
  percentualst: number;
  valoricmsst: number;
  cstipi: string;
  bcipi: number;
  percentualipi: number;
  valoripi: number;
  cstpis: string;
  bcpis: number;
  percentualpis: number;
  valorpis: number;
  cstcofins: string;
  bccofins: number;
  percentualcofins: number;
  valorcofins: number;
  voutros: number;
  bcicmsst: number;
  preducaoicms: number;
  modbc: string,
  modbcst: string,
  indtot: boolean,
}

export interface ConfirmationDialogRawProps {
  id: string;
  value: string;
  cfop: number;
  open: boolean;
  status: number;
  dados?: IFormData;
  onDados: (dados: IFormData) => void;
  onClose: (value?: string) => void;
}

const formValidationSchema: yup.ObjectSchema<Omit<IFormData, 'iditens' | 'descricao' | 'ncm'>> = yup.object().shape({
  idprod: yup.string().required(),
  cfop: yup.number().required(),
  cst: yup.string().required(),
  quantidade: yup.number().required(),
  preco: yup.number().required(),
  desconto: yup.number().required(),
  total: yup.number().required(),
  frete: yup.number().optional().default(0),
  seguro: yup.number().optional().default(0),
  bcicms: yup.number().optional().default(0),
  percentual: yup.number().optional().default(0),
  valoricms: yup.number().optional().default(0),
  bcst: yup.number().optional().default(0),
  percentualst: yup.number().optional().default(0),
  valoricmsst: yup.number().optional().default(0),
  cstipi: yup.string().optional().default(''),
  bcipi: yup.number().optional().default(0),
  percentualipi: yup.number().optional().default(0),
  valoripi: yup.number().optional().default(0),
  cstpis: yup.string().optional().default('01'),
  bcpis: yup.number().optional().default(0),
  percentualpis: yup.number().optional().default(0),
  valorpis: yup.number().optional().default(0),
  cstcofins: yup.string().optional().default('01'),
  bccofins: yup.number().optional().default(0),
  percentualcofins: yup.number().optional().default(0),
  valorcofins: yup.number().optional().default(0),
  voutros: yup.number().optional().default(0),
  bcicmsst: yup.number().optional().default(0),
  preducaoicms: yup.number().optional().default(0),
  un: yup.string().required(),
  modbc: yup.string().optional().default(''),
  modbcst: yup.string().optional().default(''),
  indtot: yup.boolean().required(),
});

export const DialoNfe: React.FC<ConfirmationDialogRawProps> = (props: ConfirmationDialogRawProps) => {

  const { formRef, save, } = useVForm();
  const { onClose, value: valueProp, open, ...other } = props;
  const [value, setValue] = useState(valueProp);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingicms, setIsLoadingicms] = useState(true);
  const [id, setId] = useState('');
  const [nomeprod, setNomeProd] = useState('');
  const [unprod, setUnProd] = useState('');
  const [ncmprod, setNcmProd] = useState('');

  const guuid = uuidv4();

  const itensnovo = {
    idprod: '',
    cfop: props.cfop,
    cst: '40',
    quantidade: 0,
    preco: 0,
    desconto: 0,
    total: 0,
    frete: 0,
    bcicms: 0,
    percentual: 0,
    valoricms: 0,
    seguro: 0,
    bcst: 0,
    percentualst: 0,
    valoricmsst: 0,
    dcicmsst: 0,
    //cstipi: 0,
    bcipi: 0,
    percentualipi: 0,
    valoripi: 0,
    cstpis: '01',
    bcpis: 0,
    percentualpis: 0,
    valorpis: 0,
    cstcofins: '01',
    bccofins: 0,
    percentualcofins: 0,
    valorcofins: 0,
    voutros: 0,
    bcicmsst: 0,
    preducaoicms: 0,
    modbcst: '',
    indtot: true,
  };

  useEffect(() => {
    if (props.id === 'novo') {
      formRef.current?.setData(itensnovo);
    } else {
      if (props.dados && typeof props.dados === 'object') {
        setNomeProd(props.dados.descricao);
        setNcmProd(props.dados.ncm);
        setUnProd(props.dados.un);

        formRef.current?.setData(props.dados);
      }
    }
  }, [id, formRef]);

  const handleSave = (dados: IFormData) => {
    formValidationSchema.
      validate(dados, { abortEarly: false })
      .then((dadosValidados) => {
        setIsLoading(true);
        if (props.id === 'novo') {
          props.onDados({ iditens: guuid, descricao: nomeprod, ncm: ncmprod, ...dadosValidados });
          onClose(value);
          setIsLoading(false);
        } else {
          props.onDados({ iditens: props.id, descricao: nomeprod, ncm: ncmprod, ...dadosValidados });
          onClose(value);
          setIsLoading(false);
        }
      })
      .catch((errors: yup.ValidationError) => {
        const validationErrors: IVFormErrors = {};
        errors.inner.forEach(error => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });
        formRef.current?.setErrors(validationErrors);
      });
  };

  const handleCancel = () => {
    onClose();
  };

  useEffect(() => {
    if (!open) {
      setValue(valueProp);
    } else {
      setId(valueProp);
    }
  }, [valueProp, open]);

  const handleProd = (descricao: string | undefined) => {
    if (descricao != null) {
      setNomeProd(descricao);
    }
  };

  const handleun = (un: string | undefined) => {
    if (un != null) {
      setUnProd(un);
    }
  };

  const handlencm = (ncm: string | undefined) => {
    if (ncm != null) {
      setNcmProd(ncm);
    }
  };

  const handlecalcularQtd = (valor: string | undefined) => {
    if (valor != null) {
      valor = valor.replace(/\D/g, '');
      valor = valor.replace(/(\d)(\d{4})$/, '$1.$2');
      valor = valor.replace(/(?=(\d{3})+(\D))\B/g, '');
      const data = formRef.current?.getData();
      const preco = data?.preco;
      const tvalor = (Number(valor) * preco);
      formRef.current?.setFieldValue('total', tvalor);
    }
  };

  const handlebcimcs = (valor: string | undefined) => {
    if (valor != null) {
      valor = valor.replace(/\D/g, '');
      valor = valor.replace(/(\d)(\d{2})$/, '$1.$2');
      valor = valor.replace(/(?=(\d{3})+(\D))\B/g, '');
      const data = formRef.current?.getData();
      const percentual = data?.percentual;
      const tvalor = (Number(valor) * percentual / 100);
      formRef.current?.setFieldValue('valoricms', tvalor);
    }
  };

  const handlepercentualicms = (valor: string | undefined) => {
    if (valor != null) {
      valor = valor.replace(/\D/g, '');
      valor = valor.replace(/(\d)(\d{2})$/, '$1.$2');
      valor = valor.replace(/(?=(\d{3})+(\D))\B/g, '');
      const data = formRef.current?.getData();
      const bcicms = data?.bcicms;
      const tvalor = (Number(valor) * bcicms / 100);
      formRef.current?.setFieldValue('valoricms', tvalor);
    }
  };

  const handlecalcularPreco = (valor: string | undefined) => {
    if (valor != null) {
      valor = valor.replace(/\./g, '');
      valor = valor.replace(/,/g, '.');
      valor = valor.replace(/(\d)(\d{4})$/, '$1.$2');
      valor = valor.replace(/(?=(\d{3})+(\D))\B/g, '');
      const data = formRef.current?.getData();
      const quantidade = data?.quantidade;
      const tvalor = (Number(valor) * quantidade);
      formRef.current?.setFieldValue('total', tvalor);
    }
  };

  const handlecst = (valor: string | undefined) => {
    if (valor != null) {
      if (valor === '3' || valor === '4' || valor === '5') {
        formRef.current?.setFieldValue('valoricms', 0);
        formRef.current?.setFieldValue('percentual', 0);
        formRef.current?.setFieldValue('bcicms', 0);
        setIsLoadingicms(true);
      } else {
        if (isLoading) {
          setIsLoadingicms(true);
        } else {
          setIsLoadingicms(false);
        }
      }
    }
  };

  return (
    <Dialog
      open={open}
      {...other}
      sx={{ width: '100%' }}
      maxWidth="md"
    >
      <DialogTitle>Itens da Nota Fiscal</DialogTitle>
      <DialogContent dividers>
        <VForm ref={formRef} onSubmit={handleSave}>
          <Grid container direction="column">
            <Grid container item direction="row" padding={1} spacing={1}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container item direction="row" spacing={2} >
                  <Grid item xs={12} sm={12} md={10} lg={8} xl={8}>
                    <AutoCompleteProdutosNfe
                      descricao={handleProd}
                      un={handleun}
                      ncm={handlencm}
                      isExternalLoading={props.status === 1 ? isLoading : true} />
                  </Grid>
                  <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
                    <VTextField
                      fullWidth
                      size='small'
                      name='un'
                      label='Unidade'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
                    <VSwitch
                      name='indtot'
                      label='Ind. Total'
                      fdisabled={props.status === 1 ? isLoading : true}
                      aliamento='top'
                    />
                  </Grid>
                  <Grid item xs={8} sm={8} md={6} lg={6} xl={6}>
                    <AutoCompleteCfop isExternalLoading={props.status === 1 ? isLoading : true} />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoney4
                      fullWidth
                      size='small'
                      name='quantidade'
                      label='Quantidade'
                      disabled={props.status === 1 ? isLoading : true}
                      calcular={handlecalcularQtd}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoney4
                      fullWidth
                      size='small'
                      name='preco'
                      label='Preço Unitario'
                      disabled={props.status === 1 ? isLoading : true}
                      calcular={handlecalcularPreco}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoney4
                      fullWidth
                      size='small'
                      name='total'
                      label='Valor Total'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <BasicSelect
                      name='cst'
                      label='Cst'
                      aoClicar={handlecst}
                      data={[
                        { nameBD: '00', descricao: '00' },
                        { nameBD: '10', descricao: '10' },
                        { nameBD: '20', descricao: '20' },
                        { nameBD: '30', descricao: '30' },
                        { nameBD: '40', descricao: '40' },
                        { nameBD: '41', descricao: '41' },
                        { nameBD: '50', descricao: '50' },
                        { nameBD: '51', descricao: '51' },
                        { nameBD: '60', descricao: '60' },
                        { nameBD: '70', descricao: '70' },
                        { nameBD: '90', descricao: '90' },
                        { nameBD: '61', descricao: '61' },
                      ]}
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <BasicSelect
                      name='modbc'
                      label='Mod BC'
                      data={[
                        { nameBD: '0', descricao: '0 - Margem Valor Agregado (%)' },
                        { nameBD: '1', descricao: '1 - Pauta (Valor)' },
                        { nameBD: '2', descricao: '2 - Preço Tabelado Máx. (valor)' },
                        { nameBD: '3', descricao: '3 - Valor da operação' },
                      ]}
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='bcicms'
                      label='B.C ICMS'
                      calcular={handlebcimcs}
                      disabled={isLoadingicms}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='percentual'
                      label='Percentual'
                      calcular={handlepercentualicms}
                      disabled={isLoadingicms}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='preducaoicms'
                      label='P. Redução ICMS'
                      disabled={isLoadingicms}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='valoricms'
                      label='Valor ICMS'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <BasicSelect
                      name='cstipi'
                      label='CST IPI'
                      data={[
                        { nameBD: '00', descricao: '00' },
                        { nameBD: '49', descricao: '49' },
                        { nameBD: '50', descricao: '50' },
                        { nameBD: '99', descricao: '99' },
                        { nameBD: '01', descricao: '01' },
                        { nameBD: '02', descricao: '02' },
                        { nameBD: '03', descricao: '03' },
                        { nameBD: '04', descricao: '04' },
                        { nameBD: '05', descricao: '05' },
                        { nameBD: '51', descricao: '51' },
                        { nameBD: '52', descricao: '52' },
                        { nameBD: '53', descricao: '53' },
                        { nameBD: '54', descricao: '54' },
                        { nameBD: '55', descricao: '55' },
                      ]}
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='bcipi'
                      label='B.C IPI'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='percentualipi'
                      label='Percentual IPI'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='valoripi'
                      label='Valor IPI'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='frete'
                      label='Frete'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='desconto'
                      label='Desconto'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <BasicSelect
                      name='cstpis'
                      label='CST PIS'
                      data={[
                        { nameBD: '01', descricao: '01' },
                        { nameBD: '02', descricao: '02' },
                        { nameBD: '03', descricao: '03' },
                        { nameBD: '04', descricao: '04' },
                        { nameBD: '05', descricao: '05' },
                        { nameBD: '06', descricao: '06' },
                        { nameBD: '07', descricao: '07' },
                        { nameBD: '08', descricao: '08' },
                        { nameBD: '09', descricao: '09' },
                        { nameBD: '49', descricao: '49' },
                        { nameBD: '50', descricao: '50' },
                        { nameBD: '51', descricao: '51' },
                        { nameBD: '52', descricao: '52' },
                        { nameBD: '53', descricao: '53' },
                        { nameBD: '55', descricao: '55' },
                        { nameBD: '56', descricao: '56' },
                        { nameBD: '60', descricao: '60' },
                        { nameBD: '61', descricao: '61' },
                        { nameBD: '62', descricao: '62' },
                        { nameBD: '63', descricao: '63' },
                        { nameBD: '64', descricao: '64' },
                        { nameBD: '65', descricao: '65' },
                        { nameBD: '66', descricao: '66' },
                        { nameBD: '67', descricao: '67' },
                        { nameBD: '70', descricao: '70' },
                        { nameBD: '71', descricao: '71' },
                        { nameBD: '72', descricao: '72' },
                        { nameBD: '73', descricao: '73' },
                        { nameBD: '74', descricao: '74' },
                        { nameBD: '75', descricao: '75' },
                        { nameBD: '98', descricao: '98' },
                        { nameBD: '99', descricao: '99' },
                      ]}
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='bcpis'
                      label='B.C PIS'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>

                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='percentualpis'
                      label='Percentual PIS'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='valorpis'
                      label='Valor PIS'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='voutros'
                      label='Outros Valor'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='seguro'
                      label='Seguro'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <BasicSelect
                      name='cstcofins'
                      label='CST CONFIS'
                      data={[
                        { nameBD: '01', descricao: '01' },
                        { nameBD: '02', descricao: '02' },
                        { nameBD: '03', descricao: '03' },
                        { nameBD: '04', descricao: '04' },
                        { nameBD: '05', descricao: '05' },
                        { nameBD: '06', descricao: '06' },
                        { nameBD: '07', descricao: '07' },
                        { nameBD: '08', descricao: '08' },
                        { nameBD: '09', descricao: '09' },
                        { nameBD: '49', descricao: '49' },
                        { nameBD: '50', descricao: '50' },
                        { nameBD: '51', descricao: '51' },
                        { nameBD: '52', descricao: '52' },
                        { nameBD: '53', descricao: '53' },
                        { nameBD: '55', descricao: '55' },
                        { nameBD: '56', descricao: '56' },
                        { nameBD: '60', descricao: '60' },
                        { nameBD: '61', descricao: '61' },
                        { nameBD: '62', descricao: '62' },
                        { nameBD: '53', descricao: '63' },
                        { nameBD: '64', descricao: '64' },
                        { nameBD: '65', descricao: '65' },
                        { nameBD: '66', descricao: '66' },
                        { nameBD: '67', descricao: '67' },
                        { nameBD: '70', descricao: '70' },
                        { nameBD: '71', descricao: '71' },
                        { nameBD: '72', descricao: '72' },
                        { nameBD: '73', descricao: '73' },
                        { nameBD: '74', descricao: '74' },
                        { nameBD: '75', descricao: '75' },
                        { nameBD: '98', descricao: '98' },
                        { nameBD: '99', descricao: '99' },
                      ]}
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='bccofins'
                      label='B.C CONFIS'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='percentualcofins'
                      label='Percentual CONFIS'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='valorcofins'
                      label='Valor CONFIS'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <BasicSelect
                      name='modbcst'
                      label='Mod BC ST'
                      data={[
                        { nameBD: '0', descricao: '0 - Preço tabelado ou máximo sugerido' },
                        { nameBD: '1', descricao: '1 - Lista Negativa (valor)' },
                        { nameBD: '2', descricao: '2 - Lista Positiva (valor)' },
                        { nameBD: '3', descricao: '3 - Lista Neutra (valor)' },
                        { nameBD: '4', descricao: '4 - Margem Valor Agregado (%)' },
                        { nameBD: '5', descricao: '5 - Pauta (valor)' },
                        { nameBD: '6', descricao: '6 - Valor da Operação' },
                      ]}
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='bcicmsst'
                      label='B.C ICMS ST'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='percentualst'
                      label='Percentual ST'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='valoricmsst'
                      label='Valor ICMS ST'
                      disabled={props.status === 1 ? isLoading : true}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </VForm>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' color='error' onClick={handleCancel}>Cancelar</Button>
        <Button variant='outlined' disabled={props.status === 1 ? isLoading : true} autoFocus onClick={save}>Confirmar</Button>
      </DialogActions>
    </Dialog>

  );
}; 